export enum EAppPicSize {
	PIC_753_423 = '753x423',
	PIC_630_380 = '630x380',
	PIC_980_370 = '980x370',
	PIC_120_60 = '120x60',
	PIC_560_210 = '560x210',
	PIC_143_113 = '143x113',
	PIC_134_104 = '134x104',
	PIC_90_70 = '90x70',
	PIC_ICO = 'ico',
}
